import { TabModel } from '../../common/types/TabModel';
import { RootStore } from '../../common/stores/context';
import { DocumentVisualStore } from '../../documents/stores';
import { AppStoreBase, DocumentPreviewStore, FormStore } from '../../custom_shared/stores';
import { DocumentService, ProjectsService, ImageService, SessionService } from '../../common/services';
import { SourceStore } from '../../custom_shared/stores';
import { AccountingStatementService } from '../services';
import { SessionsVisualStore } from '../../sessions/stores';
import SessionStore from './SessionStore';
import InputsStore from './InputsStore';
import ActionStore from './ActionStore';
import WorksheetsStore from './WorksheetsStore';
import WorksheetsSubmissionStore from './WorksheetsSubmissionStore';
import WorksheetsChangesStore from './WorksheetsChangesStore';
import ControlStateStore from './ControlStateStore';
import BusinessSearchStore from './BusinessSearchStore';

export default class AppStore extends AppStoreBase {
    readonly formStore: FormStore;
    readonly sessionStore: SessionStore;
    readonly sourceStore: SourceStore;
    readonly worksheetsStore: WorksheetsStore;
    readonly inputsStore: InputsStore;
    readonly actionStore: ActionStore;
    readonly worksheetsSubmissionStore: WorksheetsSubmissionStore;
    readonly worksheetsChangesStore: WorksheetsChangesStore;
    readonly documentVisualStore: DocumentVisualStore;
    readonly documentPreviewStore: DocumentPreviewStore;
    readonly controlStateStore: ControlStateStore;
    readonly businessSearchStore: BusinessSearchStore;

    constructor(
        readonly tab: TabModel,
        readonly rootStore: RootStore,
        private readonly sessionsVisualStore: SessionsVisualStore
    ) {
        super(tab, rootStore);

        const accountingStatementService = new AccountingStatementService();

        this.formStore = new FormStore();

        this.sessionStore = new SessionStore(this.tab, this.rootStore.iotaSessionStore, this.sessionsVisualStore);

        this.sourceStore = new SourceStore(this, this.sessionStore, new SessionService());

        this.worksheetsChangesStore = new WorksheetsChangesStore(this.sessionStore, accountingStatementService);

        this.worksheetsStore = new WorksheetsStore(
            this.sessionStore,
            this.sourceStore,
            this.worksheetsChangesStore,
            accountingStatementService
        );

        this.inputsStore = new InputsStore(this.worksheetsStore, this.worksheetsChangesStore, this.formStore);

        this.actionStore = new ActionStore(
            this.sessionStore,
            this.worksheetsStore,
            this.inputsStore,
            accountingStatementService
        );

        this.worksheetsSubmissionStore = new WorksheetsSubmissionStore(
            this.actionStore,
            this.sessionStore,
            this.worksheetsStore,
            this.formStore,
            accountingStatementService
        );

        this.documentVisualStore = new DocumentVisualStore(
            this.rootStore.applicationDefinitionsStore,
            new ImageService(),
            this.rootStore.errorStore,
            new DocumentService()
        );

        this.documentPreviewStore = new DocumentPreviewStore(
            this,
            this.inputsStore,
            this.documentVisualStore,
            new ProjectsService(),
            {
                hideMinimapOnRightSidePreview: true
            }
        );

        this.controlStateStore = new ControlStateStore(this.inputsStore, this.sessionStore);

        this.businessSearchStore = new BusinessSearchStore(
            this,
            this.sessionStore,
            this.sourceStore,
            accountingStatementService
        );
    }

    dispose() {
        this.sourceStore.dispose();
        this.worksheetsStore.dispose();
        this.worksheetsSubmissionStore.dispose();
        this.worksheetsChangesStore.dispose();
        this.inputsStore.dispose();
        this.documentPreviewStore.dispose();
        this.businessSearchStore.dispose();
        this.removeAppTab();
    }
}
